export const initialState = {
  platform: ['liveprep'],
}
